import {createOrderItemsPayload, PayloadChangeDeliveryType} from './interfaces';
// Const
import {
  GET_ORDERS,
  GET_ORDER_WITH_ID,
  UPDATE_ORDER_STATUS,
  ACTION_RETRIEVE_RUBIKA_ORDERS,
  SCHEDULE_ORDERS,
  CANCEL_ORDER,
  GET_LOGS,
  GET_ALL_ORDERS_REPORT,
  UPDATE_ALL_ORDER_STATUS,
  UPDATE_ORDER_ITEM_STATUS,
  ASSIGN_INVENTORY_ITEM_TO_ORDER_ITEM,
  ASSIGN_ORDER,
  UPDATE_ALL_ORDER_ASSIGN,
  CREATE_POST_ORDERS,
  GET_POST_ORDERS,
  GET_ORDERS_PRINT,
  CHANGE_DELIVERY_TYPE,
  ADD_ORDER_DIMENSIONS,
  DELETE_POST_ORDER,
  UPDATE_ORDER_DELIVERY_TYPE,
  GET_ORDER_ITEMS,
  CLEAR_ORDER,
  GET_TPL_LOGS,
  CREATE_ORDER_ITEMS, UPDATE_ORDER, DELETE_INVENTORY_ITEM_FROM_ORDER_ITEM, GET_PROVINCES, GET_CITIES, GET_ALL_POST_ORDERS, GET_POST_ORDER_WITH_ID, UPDATE_POST_ORDER_STATUS,
} from './constants';

// Type
import {
  Payload,
  cancelPayload,
  PayloadAllUpdate,
  PayloadAllAssigned,
} from './interfaces';
import {AssignPayload} from '../assignOrder/interfaces';

export function getOrdersAction(payload: Payload) {
  return {
    type: GET_ORDERS,
    payload,
  };
}

export function getProvincesAction(payload: Payload) {
  return {
    type: GET_PROVINCES,
    payload,
  };
}

export function getCitiesAction(payload: Payload) {
  return {
    type: GET_CITIES,
    payload,
  };
}

export function getAllOrderItemsAction(payload: Payload) {
  return {
    type: GET_ORDER_ITEMS,
    payload,
  };
}


export function createPostOrderAction(payload: Payload) {
  return {
    type: CREATE_POST_ORDERS,
    payload,
  };
}

export function getPostOrderAction(payload: Payload) {
  return {
    type: GET_POST_ORDERS,
    payload,
  };
}

export function getOrdersPrintAction(payload: Payload) {
  return {
    type: GET_ORDERS_PRINT,
    payload,
  };
}

export function getAllOrdersReportAction(payload: Payload) {
  return {
    type: GET_ALL_ORDERS_REPORT,
    payload,
  };
}

export function getPostOrdersAction(payload: Payload) {
  return {
    type: GET_ALL_POST_ORDERS,
    payload,
  };
}

export function getPostOrderWithIdAction(payload: Payload) {
  return {
    type: GET_POST_ORDER_WITH_ID,
    payload,
  };
}

export function getOrderWithIdAction(payload: {id: number}) {
  return {
    type: GET_ORDER_WITH_ID,
    payload,
  };
}

export function updateOrderStatusActions(payload: {
  id: number;
  body: any;
  pagination: object;
  callback?: () => void;
}) {
  return {
    type: UPDATE_ORDER_STATUS,
    payload,
  };
}

export function updatePostOrderStatusActions(payload: {
  id: number;
  body: any;
  pagination: object;
  callback?: () => void;
}) {
  return {
    type: UPDATE_POST_ORDER_STATUS,
    payload,
  };
}

export function updateOrderDeliveryTypeActions(payload: {
  id: number;
  body: string;
  pagination: object;
}) {
  return {
    type: UPDATE_ORDER_DELIVERY_TYPE,
    payload,
  };
}

export function addOrderDimensionsActions(payload: {
  id: number;
  body: [];
  callback?: () => void;
}) {
  return {
    type: ADD_ORDER_DIMENSIONS,
    payload,
  };
}

export function updateOrderItemStatusActions(payload: {
  id: number;
  body: string;
  pagination: object;
  callback?: () => void;
}) {
  return {
    type: UPDATE_ORDER_ITEM_STATUS,
    payload,
  };
}

export function assignInventoryItemToOrderItemActions(payload: {
  id: number;
  body: string;
  pagination: object;
}) {
  return {
    type: ASSIGN_INVENTORY_ITEM_TO_ORDER_ITEM,
    payload,
  };
}

export function deleteInventoryItemFromOrderItemActions(payload: {
  id: number;
  pagination: object;
}) {
  return {
    type: DELETE_INVENTORY_ITEM_FROM_ORDER_ITEM,
    payload,
  };
}

export function actionRetrieveRubikaOrdersAction(payload: {
  date?: string;
  from?: number;
  to?: number;
}) {
  return {
    type: ACTION_RETRIEVE_RUBIKA_ORDERS,
    payload,
  };
}

export function scheduleOrdersAction(payload: {chance: string; date?: string}) {
  return {
    type: SCHEDULE_ORDERS,
    payload,
  };
}

export function cancelOrderAction(payload: cancelPayload) {
  return {
    type: CANCEL_ORDER,
    payload,
  };
}


export function deletePostOrderAction(payload: cancelPayload) {
  return {
    type: DELETE_POST_ORDER,
    payload,
  };
}

export function getLogsAction(payload: {id: number}) {
  return {
    type: GET_LOGS,
    payload,
  };
}
export function getTPLLogsAction(payload:any) {
  return {
    type: GET_TPL_LOGS,
    payload,
  };
}

export function updateAllOrderStatusActions(payload: PayloadAllUpdate) {
  return {
    type: UPDATE_ALL_ORDER_STATUS,
    payload,
  };
}

export function updateAllOrderAssignActions(payload: PayloadAllAssigned) {
  return {
    type: UPDATE_ALL_ORDER_ASSIGN,
    payload,
  };
}

export function assignOrderAction(payload: AssignPayload) {
  return {
    type: ASSIGN_ORDER,
    payload,
  };
}

export function changeDeliveryTypeAction(payload: PayloadChangeDeliveryType) {
  return {
    type: CHANGE_DELIVERY_TYPE,
    payload,
  };
}

export function createOrderItemsAction(payload: createOrderItemsPayload) {
  return {
    type: CREATE_ORDER_ITEMS,
    payload
  }
}

export function updateOrderActions(payload: createOrderItemsPayload) {
  return {
    type: UPDATE_ORDER,
    payload
  }
}

export function clearOrderAction() {
  return {
    type: CLEAR_ORDER,
  };
}
